import apiRequest from './handler';

const userKYCService = {

    /**
     * Gets the KYC Consent IDs for Aadhaar, PAN, etc..
     * @param {string} consentFor - Comma-separated values.
     * @param {function} setIsAuthenticated - Function to update authentication state.
     * @param {function} navigate - Function to navigate to a different route.
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    getKycConsent: async (consentFor, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/common/kyc/consent?consent_for=${consentFor}`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error initiating Aadhaar KYC:', error);
            throw error;
        }
    },

    /**
     * Initializes the Aadhaar KYC process.
     * @param {string} aadhaar_number - The Aadhaar number for verification.
     * @param {function} setIsAuthenticated - Function to update authentication state.
     * @param {function} navigate - Function to navigate to a different route.
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    initAadhaarKYC: async (aadhaar_number, aadhaar_consent_id, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/common/kyc/aadhaar/init`,
                'post',
                {
                    aadhaar_number: aadhaar_number,
                    aadhaar_consent_id: aadhaar_consent_id,
                },
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error initiating Aadhaar KYC:', error);
            throw error;
        }
    },

    /**
     * Verifies the Aadhaar KYC process.
     * @param {string} request_id - The request ID for verification.
     * @param {string} otp - The OTP for Aadhaar KYC verification.
     * @param {function} setIsAuthenticated - Function to update authentication state.
     * @param {function} navigate - Function to navigate to a different route.
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    verifyAadhaarKYC: async (request_id, aadhaar_consent_id, otp, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/common/kyc/aadhaar/verify`,
                'post',
                {
                    request_id: request_id,
                    aadhaar_consent_id: aadhaar_consent_id,
                    otp: otp,
                },
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error verifying Aadhaar KYC:', error);
            throw error;
        }
    },

    /**
     * Initializes the PAN KYC process.
     * @param {string} pan_number - The PAN number for verification.
     * @param {string} urn - The URN (Unique Reference Number) for the PAN KYC.
     * @param {function} setIsAuthenticated - Function to update authentication state.
     * @param {function} navigate - Function to navigate to a different route.
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    initPanKYC: async (pan_number, pan_consent_id, urn, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/common/kyc/pan/init`,
                'post',
                {
                    "pan": pan_number,
                    "pan_consent_id": pan_consent_id,
                    "consent": "Y",
                    "consent_text": "This is for testing demo",
                    "RouteId": 1420,
                    "urn": urn
                },
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error initiating PAN KYC:', error);
            throw error;
        }
    },

    /**
     * Updates the KYC status of the user.
     * @param {function} setIsAuthenticated - Function to update authentication state.
     * @param {function} navigate - Function to navigate to a different route.
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    updateKYCstatus: async (data, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/common/kyc/complete`,
                'post',
                data,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error updating KYC status:', error);
            throw error;
        }
    },

    /**
     * Retrieves the bank name based on the provided IFSC code.
     * @param {string} ifsc - The IFSC code for the bank.
     * @param {function} setIsAuthenticated - Function to update authentication state.
     * @param {function} navigate - Function to navigate to a different route.
     * @returns {Promise} - A promise that resolves to the server's response.
     */
    verifyBankDetails: async (data, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/common/kyc/verify-bank`,
                'post',
                data,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching bank name from IFSC:', error);
            throw error;
        }
    },
    getBankNamefromIFSC: async (ifsc, setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/common/kyc/ifsc-bank-details?ifsc=${ifsc}`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching bank name from IFSC:', error);
            throw error;
        }
    },
    uploadBankProof: async (formData, setIsAuthenticated, navigate) => {
        try {
          const response = apiRequest(
            `/common/kyc/upload-bank-proof`,
            'post',
            formData,
            true,
            setIsAuthenticated,
            navigate,
            false,
        false,
     {headers: {'Content-Type': 'multipart/form-data'}}
          );
          return response;
        } catch (error) {
          console.error('Error uploading bank proof:', error);
          throw error;
        }
      },
};

export default userKYCService;
